module.exports = __webpack_public_path__ + "img/hidden.e201d6d3.png";